import { formatDate, formatTime } from "kinnect-formatters";

export default {
	name: "KDateTimeRange",

	props: {
		allDay: Boolean,

		endDate: [ Date, String ],

		endTime: String,

		startDate: [ Date, String ],

		startTime: String,

		dateFormatToken: {
			default: "MMM d",
			type: String
		},

		timeFormatToken: String,

		tag: {
			default: "div",
			type: String
		}
	},

	computed: {
		formattedEndDate() {
			return formatDate( this.endDate, this.dateFormatToken );
		},

		formattedEndTime() {
			return formatTime( this.endTime, this.timeFormatToken );
		},

		formattedStartDate() {
			return formatDate( this.startDate, this.dateFormatToken );
		},

		formattedStartTime() {
			return formatTime( this.startTime, this.timeFormatToken );
		},

		formattedDateTime() {
			if ( this.allDay ) {
				if ( this.formattedStartDate === this.formattedEndDate ) {
					return this.formattedStartDate;
				}

				return `${this.formattedStartDate} - ${this.formattedEndDate}`;
			}

			if ( this.formattedStartDate === this.formattedEndDate ) {
				return `${this.formattedStartDate}, ${this.formattedStartTime} - ${this.formattedEndTime}`;
			}

			return `${this.formattedStartDate}, ${this.formattedStartTime} - ${this.formattedEndDate}, ${this.formattedEndTime}`;
		}
	},

	render() {
		return <this.tag>{this.formattedDateTime}</this.tag>;
	}
};
